import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	origin: null,
	checkoutData: null,
	item: null, // Current item that user paid (if single & available)
	items: [], // Current items that user paid (if multiple & available)
	terminology: {},
	metaData: {},
}

/* Store payment complete UI details */
const paymentCompleteSlice = createSlice({
	name: 'paymentComplete',
	initialState,
	reducers: {
		updatePaymentCompleteDetails(state, { payload }) {
			return { ...state, ...payload }
		},
		resetPaymentCompleteDetails() {
			return { ...initialState }
		},
	},
})

export const { updatePaymentCompleteDetails, resetPaymentCompleteDetails } =
	paymentCompleteSlice.actions

export default paymentCompleteSlice.reducer
